export default __webpack_public_path__ + "static/media/cfx.2dbe653c.svg";